<template>
    <span v-if="email" class="user-teams-link inline-block">
        <teams-logo height="21" width="21" inline />
        <a class="ml-3" :href="`https://teams.microsoft.com/l/chat/0/0?users=${email}`">
            <slot>Contact me on Teams</slot>
        </a>
    </span>
</template>

<script>
import TeamsLogo from '@/components/logos/TeamsLogo.vue'

export default {
    name: 'user-teams-link',
    components: {
        TeamsLogo
    },
    props: {
        staff: {
            type: Object,
            required: true
        }
    },
    computed: {
        email() {
            return this.staff.workEmail
        }
    }
}
</script>
